import { giveawayModel } from 'entities/giveaway';
import { createAppAsyncThunk, logger } from 'shared';

import { actionTypes } from '../action-types';
import { giveawayApi } from '../api';

export const getUserQuizStats = createAppAsyncThunk(
  actionTypes.GET_USER_QUIZ_STATS,
  async (any, { rejectWithValue, dispatch }) => {
    try {
      const {
        data: { answer, isSuccessfullyAnswer },
      } = await giveawayApi.getUserQuizStats();

      dispatch(
        giveawayModel.actions.updateGiveawayState({
          userQuizAnswer: answer,
          isSuccessfullAnswer: isSuccessfullyAnswer,
        }),
      );

      return null;
    } catch (err) {
      logger('getUserQuizStats', err);
      return rejectWithValue(err);
    }
  },
);
